module.exports = __webpack_public_path__ + "static/media/covi_can_que_man.7841f7be.png";